(ns ui.view.grid-opensearch.header
  "The inner component of a column header of the new grid. The header of the ZapKit
   Table in the mockup has two lines: the name of the column, and under it the entity
   type of the column in a small gray text. AG Grid draws the sort arrow, the menu and
   the filter button itself. This component is the content of the label: the column
   def gives it `:title` and `:subtitle` in `:innerHeaderComponentParams`. The title
   is the display name of the column when the column def gives none."
  (:require
   [oops.core :as oops]
   [reagent.core :as r]))

(def dom-overrides
  "Classes that the generated Table styles do not have, because AG Grid draws the
   header cell. The title takes the font of the header from the theme. The subtitle is
   12 px, normal weight, in the tertiary text color, and it ends with an ellipsis."
  {:root     "tw2-flex tw2-min-w-0 tw2-flex-col"
   :title    "tw2-truncate tw2-leading-5"
   :subtitle "tw2-truncate tw2-text-xs tw2-font-normal tw2-leading-4 tw2-text-tertiary"})

(defn header-hiccup
  "The hiccup of the header label. The subtitle is not drawn when it is blank."
  [{:keys [title subtitle]}]
  [:div {:class (:root dom-overrides)}
   [:span {:class (:title dom-overrides)}
    title]
   (when (seq subtitle)
     [:span {:class (:subtitle dom-overrides)}
      subtitle])])

(defn inner-header
  "The `innerHeaderComponent` of a column def. `props-js` has the params of the header
   and `:innerHeaderComponentParams` merged in."
  [props-js]
  (r/as-element
   (header-hiccup {:title    (or (oops/oget+ props-js "title")
                                 (oops/oget+ props-js "displayName"))
                   :subtitle (oops/oget+ props-js "subtitle")})))
